//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SvgIcon from '@/components/svg-icon-nc';
export default {
  name: 'chartStyle-editor',
  components: {
    SvgIcon: SvgIcon
  },
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      option: {},
      stylesList: [{
        type: 'barChart',
        list: [{
          type: 1,
          label: '普通柱状图',
          icon: 'icona-zu10206'
        }, {
          type: 2,
          label: '堆积状态图',
          icon: 'icona-zu10212'
        }, {
          type: 3,
          label: '百分比堆积状态图',
          icon: 'icona-zu10210'
        }]
      }, {
        type: 'barXChart',
        list: [{
          type: 1,
          label: '普通条形图',
          icon: 'icona-zu10218'
        }, {
          type: 2,
          label: '堆积条形图',
          icon: 'icona-zu10220'
        }, {
          type: 3,
          label: '百分比堆积条形图',
          icon: 'icona-zu10222'
        }]
      }, {
        type: 'lineChart',
        list: [{
          type: 1,
          label: '折线图',
          icon: 'icona-zu10205'
        }, {
          type: 2,
          label: '曲线图',
          icon: 'icona-zu10202'
        }]
      }, {
        type: 'pieChart',
        list: [{
          type: 1,
          label: '实心',
          icon: 'icona-zu10087'
        }, {
          type: 2,
          label: '环形',
          icon: 'icona-zu10083'
        }]
      }, {
        type: 'progressbar',
        list: [{
          type: 1,
          label: '环形',
          icon: 'icona-zu10087'
        }, {
          type: 2,
          label: '进度条',
          icon: 'icona-zu10216-01'
        }, {
          type: 3,
          label: '水波图',
          icon: 'icona-zu10086-2'
        }]
      }]
    };
  },
  watch: {
    optionModel: {
      handler: function handler(newVal) {
        this.initchartStyle();
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    this.initchartStyle();
  },
  methods: {
    initchartStyle: function initchartStyle() {
      this.option = this.optionModel;
    },
    checkIsDisabled: function checkIsDisabled(item, chartType) {
      if (this.option.setDimensional) {
        var _this$option$setDimen = this.option.setDimensional,
          dimension = _this$option$setDimen.dimension,
          metrics = _this$option$setDimen.metrics;
        if ((chartType == 'barChart' || chartType == 'barXChart') && item.type != 1 && (dimension.length > 1 || metrics.length < 2)) {
          return true;
        }
      }
      return false;
    },
    chartStyleChange: function chartStyleChange(item) {
      if (this.option.chartStyle == item.type) {
        return;
      }
      this.option.chartStyle = item.type;
      this.$emit('update:optionModel', this.option);
    }
  }
};